var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-select',{attrs:{"plain":"","value":_vm.$i18n.locale},on:{"input":_vm.toggleLang}},[_c('option',{attrs:{"value":"en"}},[_vm._v("English 英语")]),_c('option',{attrs:{"value":"cn"}},[_vm._v("Chinese 中文")])])}
var staticRenderFns = []

export { render, staticRenderFns }